import { useState } from 'react';
import './gender.css';
import lockShieldImg from '../assets/icon.png';

function ChevronLeftIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M15 5l-7 7 7 7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function ShieldIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 3l7 3v5c0 5-3.4 8.4-7 10-3.6-1.6-7-5-7-10V6l7-3Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function CheckIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path d="M5 12.5l4.5 4.5L19 7" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function ArrowRightIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function MaleAvatar() {
  return (
    <svg width="90" height="90" viewBox="0 0 90 90">
      <path d="M12 90c0-15 15-24 33-24s33 9 33 24Z" fill="#7457e8" />
      <ellipse cx="45" cy="42" rx="19" ry="21" fill="#f2c19b" />
      <path
        d="M22 40c0-16 10-25 23-25s23 9 23 25c-3-4-8-6-12-4-2-6-8-8-11-8s-9 2-11 8c-4-2-9 0-12 4Z"
        fill="#2b2233"
      />
      <circle cx="37" cy="43" r="2.6" fill="#2b2233" />
      <circle cx="53" cy="43" r="2.6" fill="#2b2233" />
      <path d="M39 52c2 2.5 8 2.5 10 0" stroke="#c07a4f" strokeWidth="2" strokeLinecap="round" fill="none" />
    </svg>
  );
}

function FemaleAvatar() {
  return (
    <svg width="90" height="90" viewBox="0 0 90 90">
      <path d="M14 90c0-14 14-22 31-22s31 8 31 22Z" fill="#ec5c9d" />
      <path d="M20 38c0-15 11-27 25-27s25 12 25 27c0 6-2 12-4 16-1-10-4-14-6-16 1 6-1 12-4 15 0-7-2-11-4-13-3 8-9 12-14 12s-11-4-14-12c-2 2-4 6-4 13-3-3-5-9-4-15-2 2-5 6-6 16-2-4-4-10-4-16Z" fill="#3d2b1f" />
      <ellipse cx="45" cy="44" rx="17" ry="19" fill="#f5cba5" />
      <path d="M18 46c-3 6-3 16 2 24-2-9 0-18 3-22Z" fill="#3d2b1f" />
      <path d="M72 46c3 6 3 16-2 24 2-9 0-18-3-22Z" fill="#3d2b1f" />
      <circle cx="38" cy="44" r="2.4" fill="#2b2233" />
      <circle cx="52" cy="44" r="2.4" fill="#2b2233" />
      <path d="M39 53c2 2.2 7 2.2 9 0" stroke="#c26a8e" strokeWidth="2" strokeLinecap="round" fill="none" />
    </svg>
  );
}

const OPTIONS = [
  { key: 'male', label: 'Male', Avatar: MaleAvatar },
  { key: 'female', label: 'Female', Avatar: FemaleAvatar },
];

export default function GenderStep({ onBack, onContinue }) {
  const [gender, setGender] = useState('male');

  return (
    <div className="gender-screen">
      <div className="gender-frame">
        <div className="gender-header">
          <button type="button" className="gender-back-btn" onClick={onBack} aria-label="Go back">
            <ChevronLeftIcon />
          </button>

          <div className="gender-glow" />
          <div className="gender-icon-wrap">
            <img src={lockShieldImg} alt="" className="gender-icon-img" />
          </div>
          <h1 className="gender-title">What&apos;s your gender?</h1>
          <p className="gender-subtitle">This helps us personalize your experience</p>
        </div>

        <form
          className="gender-card"
          onSubmit={(e) => {
            e.preventDefault();
            onContinue?.({ gender });
          }}
        >
          <h2 className="gender-card-title">Select your gender</h2>
          <p className="gender-card-subtitle">Choose the option that best describes you</p>

          <div className="gender-options">
            {OPTIONS.map(({ key, label, Avatar }) => {
              const selected = gender === key;
              return (
                <button
                  key={key}
                  type="button"
                  className={`gender-option ${key} ${selected ? 'selected' : ''}`}
                  onClick={() => setGender(key)}
                  aria-pressed={selected}
                >
                  <div className={`gender-avatar ${key}`}>
                    <Avatar />
                  </div>
                  <span className="gender-option-label">{label}</span>
                  <span className={`gender-radio ${selected ? 'checked' : ''}`}>
                    {selected && <CheckIcon />}
                  </span>
                </button>
              );
            })}
          </div>

          <div className="gender-privacy">
            <div className="gender-privacy-icon">
              <ShieldIcon />
            </div>
            <div>
              <p className="gender-privacy-title">Your information is private</p>
              <p className="gender-privacy-text">
                Your gender is only visible to you and will not be shared with others.
              </p>
            </div>
          </div>

          <button type="submit" className="gender-submit">
            Continue <ArrowRightIcon />
          </button>
        </form>
      </div>
    </div>
  );
}
